import FireImg from '../../Image/Icon/Fire.svg'

export default function Title({ text, center = false }) {
    return (
        <div className={`relative mt-5 ${center ? 'flex justify-center text-center' : ''}`}>
            <h1 className='text-[#333] dark:text-[#fff] font-bold text-[20px] lg:text-3xl '>
                {text}
            </h1>
            <div className={`absolute top-1/2 ${center ? 'left-1/2' : 'right-0'} -translate-y-1/2 -z-10`}>
                <img src={FireImg} className='w-[60px] -rotate-[15deg]' />
            </div>
        </div>
    )
}
